export default __webpack_public_path__ + "static/media/tip-1.b9b349d6.png";